<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsFeedbackTracker from '@/@core/components/feedback/AnalyticsFeedbackTracker.vue'
import CustomerCommunicationDrawer from '@/views/feedback/customer-communication/Drawer.vue'
import CustomerCommunicationLogDrawer from '@/views/feedback/customer-communication/LogDrawer.vue'
import FeedbackTable from '@/views/feedback/feedback-panel/FeedbackTable.vue'
import FeedbackDrawerV2 from '@/views/feedback/feedback-panel/drawer/FeedbackDrawerV2.vue'
import FeedbackResponseDrawer from '@/views/feedback/feedback-panel/drawer/FeedbackResponseDrawer.vue'
import TicketSuggestionDrawer from '@/views/feedback/feedback-panel/drawer/TicketSuggestionDrawer.vue'

definePage({
  meta: {
    name: 'feedback-panel',
    subject: 'feedback.menu',
    action: 'feedback_panel',
  },  
})

const route = useRoute()

const feedbackFilters = ref({})
const { data: filterOptions } = await useApi(createUrl('/feedbacks/filters'))

const isFeedbackDrawerVisible = ref(false)
const isFeedbackResponseDrawerVisible = ref(false)
const feedbackDrawerData = ref()
const feedbackResponseDrawerData = ref()
const feedbackDrawerType = ref('View')

const communicationDrawerData = ref()
const communicationDrawerType = ref('View')

const showFeedback = (feedbackData, type) => {
  feedbackDrawerData.value = feedbackData
  feedbackDrawerType.value = type  
  isFeedbackDrawerVisible.value = true
}

const showFeedbackResponse = feedbackData => {
  feedbackResponseDrawerData.value = feedbackData
  isFeedbackResponseDrawerVisible.value = true
}

const isCommunicationDrawerVisible = ref(false)

const showCommunicationDrawer= (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationDrawerVisible.value = true
}

const isCommunicationLogDrawerVisible = ref(false)

const showCommunicationLogDrawer = (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationLogDrawerVisible.value = true
}

const feedbackTable = ref(null)
const feedbackTracker = ref(null)

const refreshFeedbackTable = () => {
  feedbackTable.value?.fetchFeedbacks()
  feedbackTracker.value?.fetchStatusGraph()
}

// check if feedback id is present in the route
if(route.query.feedback){
  const feedbackId = route.query.feedback
  const { data: feedbackData } = await useApi(createUrl(`/feedbacks/feedbacks/${feedbackId}`))
  if(feedbackData.value){
    showFeedback(feedbackData.value, 'View')
  }
}

const isTicketSuggestionDrawerVisible = ref(false)

const showTicketSuggestionDrawer = feedbackData => {
  feedbackDrawerData.value = feedbackData
  isTicketSuggestionDrawerVisible.value = true
}
</script>

<template>
  <section>
    <VRow class="match-height">
      <VCol
        cols="12"
        md="6"
      >
        <FilterComponent
          v-model:filters="feedbackFilters"
          :filters-options="filterOptions"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>
      <VCol
        cols="12"
        md="6"
      >
        <AnalyticsFeedbackTracker
          ref="feedbackTracker"
          class="h-100" 
          :feedback-filters="feedbackFilters"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>

      <VCol cols="12">
        <FeedbackTable
          ref="feedbackTable"
          :feedback-filters="feedbackFilters"
          @show-feedback="showFeedback"
          @show-feedback-response="showFeedbackResponse"
          @show-communication-drawer="showCommunicationDrawer"
          @show-communication-log-drawer="showCommunicationLogDrawer"
          @show-ticket-suggestion-drawer="showTicketSuggestionDrawer"
        />
      </VCol>
    </VRow>

  
    <FeedbackResponseDrawer
      v-model:isDrawerOpen="isFeedbackResponseDrawerVisible"
      :feedback-data="feedbackResponseDrawerData"
      @show-communication-drawer="showCommunicationDrawer"
    />

    <CustomerCommunicationDrawer
      v-model:isDrawerOpen="isCommunicationDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="feedback_customer_communication"
    />

    <CustomerCommunicationLogDrawer
      v-model:isDrawerOpen="isCommunicationLogDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="feedback_customer_communication"
    />

    <FeedbackDrawerV2
      v-model:isDrawerOpen="isFeedbackDrawerVisible"
      :feedback-data="feedbackDrawerData"
      @show-feedback="showFeedback"
      @show-feedback-response="showFeedbackResponse"
      @show-communication-drawer="showCommunicationDrawer"
      @update:type="feedbackDrawerType = $event"
      @refresh-feedback-table="refreshFeedbackTable"
    />

    <TicketSuggestionDrawer
      v-model:isDrawerOpen="isTicketSuggestionDrawerVisible"
      :feedback-data="feedbackDrawerData"
    />
  </section>
</template>
